<template>
  <BModal
    :id="id"
    no-stacking
    centered
    hide-footer
    hide-header
    size="md"
    body-class="p-2"
  >
    <b-row class="justify-content-center position-relative mb-2">
      <b-img
        src="https://storage.googleapis.com/komerce/assets/icons/Icon-Popup.svg"
        alt="Warning Icon"
        width="80"
      />
      <b-img
        src="https://storage.googleapis.com/komerce/assets/svg/round-delete.svg"
        class="cursor-pointer position-absolute top-0 right-4"
        width="20"
        @click="closeModal"
      />
    </b-row>
    <div class="modal-content-wrapper">
      <!-- Header Section -->
      <div class="modal-header-section mb-2">
        <h2 class="modal-title text-center mb-1 text-black">
          {{ modalTitle }}
        </h2>
        <p class="modal-subtitle text-center">
          {{ modalDescription }}
        </p>
      </div>
      <div
        v-if="isTiktokPlatform"
        class="d-flex align-items-center mb-2 gap-2 bg-[#E6F4FF] p-1 rounded-lg border-[#91CAFF] border-2"
      >
        <b-img
          src="https://storage.googleapis.com/komerce/assets/icons/info-circle-fill-blue.svg"
          alt="Info Icon"
          width="20"
        />
        <p class="m-0 text-sm text-black">
          Permintaan akan kami proses pada jam kerja (Senin - Jumat, 08:00 - 20:00) dan pembatasan hanya berlaku untuk platform TikTok
        </p>
      </div>
      <p
        class="mb-2 text-center"
      >Klik <span class="font-medium text-black">Ya, Ajukan</span> untuk mengirim pengajuan akun whitelist</p>
      <div class="d-flex justify-items-stretch gap-3">
        <b-button
          class="w-100"
          variant="outline-primary"
          @click="closeModal"
        >
          Batal
        </b-button>
        <b-button
          class="w-100"
          variant="primary"
          @click="$emit('onContinue')"
        >
          Ya, Ajukan
        </b-button>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'modal-topup-confirmation',
    },
    platformName: {
      type: String,
      default: '',
    },
    source: {
      type: String,
      default: '',
    },
  },
  computed: {
    isTiktokPlatform() {
      return this.platformName?.toLowerCase() === 'tiktok'
    },
    isSubscription() {
      return this.source === 'subscription'
    },
    modalDescription() {
      if (this.isSubscription) {
        return 'Pastikan data yang kamu inputkan sudah benar dan sesuai. Setelah pengajuan dikirim, proses akan dilanjutkan untuk peninjauan akun whitelist.'
      }
      if (this.platformName?.toLowerCase() === 'meta') {
        return 'Top Up pada platform iklan Meta akan langsung terproses ke akun tujuan. Apabila status masih "Diproses", silakan hubungi Customer Service.'
      }
      return `Top up akun ${this.platformName} kamu sedang diproses dan akan selesai maksimal dalam 1 jam. Jika saldo belum bertambah, silakan hubungi Customer Service.`
    },
    modalTitle() {
      if (this.isSubscription) {
        return 'Konfirmasi Pengajuan'
      }
      return 'Konfirmasi Topup'
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this.id)
    },
  },
}
</script>

<style scoped>
/* Targeting modal root */
  [id*="___BV_modal_outer_"] {
    z-index: 10000000 !important;
  }
</style>
